import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['label']

  connect () {
    useClickOutside(this);
  }

  replaceSelectLabel (event) {
    this.labelTarget.innerText = event.target.labels[0].innerText;
    this.labelTarget.classList.add('dropdown__selection--selected');
    this.hide();
  }

  hide () {
    document.getElementById(this.labelTarget.htmlFor).checked = false;
  }
}
